import { Component, OnInit, Input } from '@angular/core';
import { WizardStep } from '../../../_models/_index';
import { DealStepEnum } from '../../../_enums/_index';

@Component({
    selector: 'deal-stepper',
    templateUrl: './deal-stepper.component.html',
    styleUrls: ['./deal-stepper.component.css']
})
export class DealStepperComponent implements OnInit {
    wizardSteps: WizardStep[];
    @Input()
    dealStep: DealStepEnum;

    constructor() {
    }

    ngOnInit() {
        this.wizardSteps = [
            {
                "value": DealStepEnum.Package,
                "name": "חבילה",
                "cssClass": "box"
            },
            {
                "value": DealStepEnum.Details,
                "name": "פרטי מנוי",
                "cssClass": "user"
            },
            {
                "value": DealStepEnum.Payment,
                "name": "תשלום",
                "cssClass": "card"
            },
            {
                "value": DealStepEnum.Terms,
                "name": "תנאי שימוש",
                "cssClass": "doc"
            },
            {
                "value": DealStepEnum.Approval,
                "name": "אישור",
                "cssClass": "like"
            }
        ];

    }
}



// WEBPACK FOOTER //
// ./src/app/components/deal-wizard/deal-stepper/deal-stepper.component.ts